import { selectDealersReport } from 'core/config/firebase/remote-config-slice';
import { useAppSelector } from 'core/hooks/use-app-selector';
import { DealersReportConfig } from 'feature/dealers/models/dealers-report-config';
import { useEffect, useState } from 'react';

const useDealersReportConfig = () => {
  const [dealersReportUrl, setDealersReportUrl] = useState<string | undefined>();
  const { user } = useAppSelector((state) => state.auth);
  const dealersReport = useAppSelector(selectDealersReport);
  const [rolloutUserSet, setRolloutUserSet] = useState<string[]>([]);
  const userType = user?.type?.toLowerCase();

  const excludedUserTypes = new Set(['dealer', 'distributor']);

  useEffect(() => {
    if (dealersReport) {
      try {
        const dealersReportConfig: DealersReportConfig = JSON.parse(dealersReport ?? '{}');
        setDealersReportUrl(dealersReportConfig.report);
        setRolloutUserSet(dealersReportConfig.users ?? []);
      } catch {
        setDealersReportUrl(undefined);
        setRolloutUserSet([]);
      }
    } else {
      setDealersReportUrl(undefined);
      setRolloutUserSet([]);
    }
  }, [dealersReport]);

  const isDealersReportEnabled = (userId?: string): boolean => {
    if (userType === 'dealer' || !dealersReportUrl || !rolloutUserSet || !userId) {
      return false;
    }
    if (rolloutUserSet.length === 0) {
      return false;
    }
    if (userType && excludedUserTypes.has(userType)) {
      return false;
    }
    return (rolloutUserSet.includes('*') || rolloutUserSet.includes(userId));
  };
  return {
    dealersReportUrl,
    isDealersReportEnabled,
  };
};
export { useDealersReportConfig };
